// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AnimatedButton = registerClientReference(
    function() { throw new Error("Attempted to call AnimatedButton() from the server but AnimatedButton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "AnimatedButton",
);
export const AnimatedCard = registerClientReference(
    function() { throw new Error("Attempted to call AnimatedCard() from the server but AnimatedCard is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "AnimatedCard",
);
export const PageTransition = registerClientReference(
    function() { throw new Error("Attempted to call PageTransition() from the server but PageTransition is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "PageTransition",
);
export const Reveal = registerClientReference(
    function() { throw new Error("Attempted to call Reveal() from the server but Reveal is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "Reveal",
);
export const RevealGroup = registerClientReference(
    function() { throw new Error("Attempted to call RevealGroup() from the server but RevealGroup is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "RevealGroup",
);
export const RevealItem = registerClientReference(
    function() { throw new Error("Attempted to call RevealItem() from the server but RevealItem is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "RevealItem",
);
export const ScrollProgress = registerClientReference(
    function() { throw new Error("Attempted to call ScrollProgress() from the server but ScrollProgress is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "ScrollProgress",
);
export const ScrollReveal = registerClientReference(
    function() { throw new Error("Attempted to call ScrollReveal() from the server but ScrollReveal is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "ScrollReveal",
);
export const StaggerContainer = registerClientReference(
    function() { throw new Error("Attempted to call StaggerContainer() from the server but StaggerContainer is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "StaggerContainer",
);
export const StaggerItem = registerClientReference(
    function() { throw new Error("Attempted to call StaggerItem() from the server but StaggerItem is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/motion.tsx",
    "StaggerItem",
);
